module.exports = __webpack_public_path__ + "static/img/avatar-7.9524b09f.jpg";